import React from "react";
import PropTypes from "prop-types";
import { FormProvider, useForm } from "react-hook-form";

import StatusItem from "./StatusItem";
import DocumentMIP from "../../../../modules/Habitacional/pages/ChooseCoverageToActivate/FormMIP/StepTwo/FormStepTwoMIP";

import { ReactComponent as AdvisedIcon } from "../../../../assets/images/habitacional/tracking/advised-icon.svg";
import { ReactComponent as DocumentPeddingIcon } from "../../../../assets/images/habitacional/tracking/document-pedding.svg";
import { ReactComponent as MedicalAnalysisIcon } from "../../../../assets/images/habitacional/tracking/medical-analysis.svg";
import { ReactComponent as AnalyzedIcon } from "../../../../assets/images/habitacional/tracking/analyzed-icon.svg";
import { ReactComponent as SurveyIcon } from "../../../../assets/images/habitacional/tracking/survey-icon.svg";
import { ReactComponent as AnalyzingIcon } from "../../../../assets/images/habitacional/tracking/analysing-icon.svg";

import * as S from "./TrackingStatus.Style";

const EnumMIPCausas = {
  "Morte por doença": {
    id: 9,
    label: "Morte por doença",
  },
  "Morte por acidente": {
    id: 10,
    label: "Morte por acidente",
  },
  "Invalidez por doença": {
    id: 11,
    label: "Invalidez por doença",
  },
  "Invalidez por acidente": {
    id: 12,
    label: "Invalidez por acidente",
  },
};

const tracks = {
  DIF: {
    fluxo: {
      icon: AdvisedIcon,
    },
    vistoria: {
      icon: AnalyzingIcon,
    },
    analiseFluxo: {
      icon: SurveyIcon,
    },
    finalizacaoFluxo: {
      icon: AnalyzedIcon,
    },
  },
  MIP: {
    fluxo: {
      icon: AdvisedIcon,
    },
    vistoria: {
      icon: DocumentPeddingIcon,
    },
    analiseFluxo: {
      icon: MedicalAnalysisIcon,
    },
    finalizacaoFluxo: {
      icon: AnalyzedIcon,
    },
  },
};

const getCurrentTitle = (currentPedido) => {
  if (!currentPedido) {
    return "";
  }

  if (currentPedido?.analiseFluxo?.natureza === "MIP") {
    return currentPedido?.analiseFluxo?.causa;
  }

  return currentPedido?.codNatureza === 1
    ? "Danos Físicos ao Imóvel"
    : "Morte ou Invalidez Permanente";
};

const TrackingStatus = ({ pedidos }) => {
  const methods = useForm({
    resolver: {},
    defaultValues: {},
    mode: "onChange",
    reValidateMode: "onChange",
  });

  return (
    <S.Container>
      <S.TrackingTitlePage>
        Confira o andamento do(s) seu(s) pedido(s)
      </S.TrackingTitlePage>

      {Array?.isArray(pedidos) &&
        pedidos.map((pedido) => {
          const isMIP = pedido?.analiseFluxo?.natureza === "MIP";

          const isDocumentPending = String(pedido?.documentoFluxo?.observacao)
            .toLocaleLowerCase()
            .includes("aguardando documentação");

          const currentConfirmCause =
            EnumMIPCausas?.[pedido?.analiseFluxo?.causa];

          const currentTrack =
            tracks[pedido?.analiseFluxo?.natureza] || tracks.DIF;

          return (
            <React.Fragment key={pedido?.id}>
              <S.TrackTitle>
                Pedido número <S.TrackNumber>{pedido?.id}</S.TrackNumber>
                <br />
                {getCurrentTitle(pedido)}
              </S.TrackTitle>

              <S.StatusList>
                <StatusItem
                  title={pedido?.pedidoFluxo?.observacao}
                  description={new Date(
                    pedido?.pedidoFluxo?.data
                  ).toLocaleDateString("pt-BR")}
                  icon={
                    <currentTrack.fluxo.icon
                      className="status-icon"
                      style={{
                        color: pedido?.pedidoFluxo?.completo
                          ? "#5B8E00"
                          : "#6F7C87",
                      }}
                    />
                  }
                  isCompleted={pedido?.pedidoFluxo?.completo}
                  currentStep={pedido?.pedidoFluxo?.ativo}
                />
                {isMIP && (
                  <StatusItem
                    title={pedido?.documentoFluxo?.observacao}
                    description={
                      pedido?.documentoFluxo?.completo
                        ? new Date(
                            pedido?.documentoFluxo?.dataEmissao
                          ).toLocaleDateString("pt-BR")
                        : "Em andamento"
                    }
                    icon={
                      <currentTrack.vistoria.icon
                        className="status-icon"
                        style={{
                          color: pedido?.documentoFluxo?.completo
                            ? "#5B8E00"
                            : "#6F7C87",
                        }}
                      />
                    }
                    isCompleted={pedido?.documentoFluxo?.completo}
                    currentStep={pedido?.documentoFluxo?.ativo}
                  />
                )}
                {!isMIP && (
                  <StatusItem
                    title={pedido?.vistoriaFluxo?.observacao}
                    description={
                      pedido?.vistoriaFluxo?.completo
                        ? new Date(
                            pedido?.vistoriaFluxo?.dataAbertura
                          ).toLocaleDateString("pt-BR")
                        : "Em andamento"
                    }
                    icon={
                      <currentTrack.vistoria.icon
                        className="status-icon"
                        style={{
                          color: pedido?.vistoriaFluxo?.completo
                            ? "#5B8E00"
                            : "#6F7C87",
                        }}
                      />
                    }
                    isCompleted={pedido?.vistoriaFluxo?.completo}
                    currentStep={pedido?.vistoriaFluxo?.ativo}
                  />
                )}
                <StatusItem
                  title={pedido?.analiseFluxo?.observacao}
                  description={
                    pedido?.analiseFluxo?.ativo ||
                    pedido?.analiseFluxo?.completo
                      ? new Date(
                          pedido?.analiseFluxo?.dataCadastro
                        ).toLocaleDateString("pt-BR")
                      : "Aguardando"
                  }
                  icon={
                    <currentTrack.analiseFluxo.icon
                      className="status-icon"
                      style={{
                        color: pedido?.analiseFluxo?.completo
                          ? "#5B8E00"
                          : "#6F7C87",
                      }}
                    />
                  }
                  isCompleted={pedido?.analiseFluxo?.completo}
                  currentStep={pedido?.analiseFluxo?.ativo}
                />
                <StatusItem
                  title={pedido?.finalizacaoFluxo?.observacao}
                  description={
                    pedido?.finalizacaoFluxo?.completo
                      ? new Date(
                          pedido?.finalizacaoFluxo?.dataFinalizacao
                        ).toLocaleDateString("pt-BR")
                      : "Aguardando"
                  }
                  icon={
                    <currentTrack.finalizacaoFluxo.icon
                      className="status-icon"
                      style={{
                        color: pedido?.finalizacaoFluxo?.completo
                          ? "#5B8E00"
                          : "#6F7C87",
                      }}
                    />
                  }
                  isCompleted={pedido?.finalizacaoFluxo?.completo}
                  currentStep={pedido?.finalizacaoFluxo?.ativo}
                />
              </S.StatusList>
              <S.Divider />

              {isMIP && isDocumentPending && currentConfirmCause && (
                <>
                  <S.TrackingTitlePage>
                    Documentos pendentes
                  </S.TrackingTitlePage>

                  <FormProvider {...methods}>
                    <DocumentMIP
                      comunicatorId={pedido?.id}
                      confirmCause={currentConfirmCause}
                      title="Lista de documentos"
                      description={
                        <>
                          Lista dos documentos a serem enviados para a abertura
                          do sinistro de{" "}
                          <strong>{pedido?.analiseFluxo?.causa}</strong>.
                        </>
                      }
                    />
                  </FormProvider>
                </>
              )}
            </React.Fragment>
          );
        })}
    </S.Container>
  );
};

TrackingStatus.propTypes = {
  pedidos: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};

TrackingStatus.defaultProps = {
  pedidos: [],
};

export default TrackingStatus;
